import React, {  useMemo } from 'react';
import { styled } from 'linaria/react';
import { cx } from 'linaria';
import { theme } from '../Theme';

const StoreListContainer = styled('div')`
  max-width: 1140px;
  margin: auto;
  display: flex;
  flex-direction: column;
  .highlight {
    background: yellow;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  section.region-section {
    padding: 1rem;
    order: 2;
    &.region-sverige {
      order: 1;
    }
    h2 {
      text-align: left;
      margin: 1rem 0;
      padding: 1rem 0;
      border-bottom: 1px solid black;
    }
    h3 {
      cursor: pointer;
      font-weight: 400;
      font-size: 1rem;
      margin: 0.5rem 0;
    }
    a {
      display: block;
      text-decoration: none;
      color: black;
      cursor: pointer;
      font-weight: 400;
      font-size: 1rem;
      margin: 0.5rem 0;
      &:hover {
        text-decoration: underline;
      }
    }
    div.storeList {
      column-count: 1;
      ${theme.above.lg} {
        column-count: 4;
      }
      ${theme.above.sm} {
        column-count: 3;
      }
    }
  }
`;

// TODO: Add distance to store list
// const humanDistance = distance =>
//   distance > 10
//     ? t('{km} km', { km: Math.round(distance) })
//     : distance > 1
//     ? t('{km} km', { km: distance.toFixed(1) })
//     : t('{m} m', { m: Math.round(distance * 1000) });

const toUrlFormat = (storeName) => {
  return storeName
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '') // Normalize special characters
  .replace(/[åä]/g, 'a')
  .replace(/[öø]/g, 'o')
  .replace(/[æ]/g, 'e')
  .replace(',', '-') // Replace comma with a dash
  .replace(/\s+/g, '-') // Replace all spaces with dashes
  .replace(/-+/g, '-') // Collapse multiple dashes into one
  .toLowerCase()
  .trim('-'); // Remove any leading/trailing dashes
};

const Store = ({ distances, setSelectedStore, store }) => {
  const urlFormatName = toUrlFormat(store?.name);
  return (
    <a
      href={`/stores/${urlFormatName}`}
      onClick={event => {
        event.preventDefault();
        setSelectedStore(store);
        if (typeof window !== 'undefined') {
          const blockPos = window.innerWidth < 600 ? 'start' : 'center';
          document.getElementById('mapWrap').scrollIntoView({
            behavior: 'smooth',
            block: blockPos
          });
        }
      }}
    >
      {store?.name}
    </a>
  );
};

const StoreList = ({ stores, userLocation, distances, setSelectedStore }) => {
  const groupedStores = useMemo(() => {
    return stores.reduce(
      (objectsByKeyValue, obj) => ({
        ...objectsByKeyValue,
        [obj['region']]: (objectsByKeyValue[obj['region']] || []).concat(obj)
      }),
      {}
    );
  }, [stores]);
  return (
    <StoreListContainer>
      {groupedStores &&
        Object.entries(groupedStores).map(region => {
          return (
            <section
              className={cx(
                `region-${region[0].toLowerCase()}`,
                'region-section'
              )}
            >
              <h2>{region[0]}</h2>
              <div className="storeList">
                {region[1].map(store => (
                  <Store store={store} setSelectedStore={setSelectedStore} />
                ))}
              </div>
            </section>
          );
        })}
    </StoreListContainer>
  );
};

export default StoreList;
